import { categories } from '@/mocks/homeData';

export default function CategoryGrid() {
  return (
    <section className="relative py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-10 md:mb-14">
          <span className="inline-block text-xs font-semibold text-foreground-400 uppercase tracking-widest mb-3">
            Explore
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
            Product Categories
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl">
            Browse our organized <strong>AllChinaBuy Spreadsheet</strong> categories with curated products,
            QC photos, and trusted seller listings. Click any category to explore on our main store.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-xl bg-background-100 hover:bg-accent-50 border border-background-200/60 hover:border-accent-200 transition-all duration-200 cursor-pointer overflow-hidden"
            >
              {/* Category Image */}
              <div className="aspect-[5/4] overflow-hidden bg-background-200">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  title={`${cat.name} - AllChinaBuy Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>

              {/* Content */}
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2.5 mb-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-accent-200 group-hover:text-accent-700 transition-colors">
                    <i className={`${cat.icon} text-sm`}></i>
                  </span>
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 whitespace-nowrap">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {cat.description}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-accent-600 group-hover:text-accent-700 whitespace-nowrap">
                  Browse Category
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}